import { EndScreen } from './end-screen';
import { EndScreenType } from './end-screen-types';

interface EndScreenImageConfig {
  skin?: {
    endScreenImage?: string;
  };
  endScreen?: {
    closeBtn?: {
      delay?: number;
      size?: number;
    };
  };
  closeBtn?: {
    autoCloseDelay?: number;
  };
}

export class EndScreenImage extends EndScreen {
  content: string;

  constructor({ config }: { config: EndScreenImageConfig }) {
    super({ config });
    this.content = (config && config.skin && config.skin.endScreenImage) || '';
    this.type = EndScreenType.IMAGE;
  }

  isValid(): boolean {
    return Boolean(this.content) && this.duration > 0;
  }
}
